import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=e0e26d22&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=e0e26d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e26d22",
  null
  
)

export default component.exports